<template>
  <div ref="" class="d-flex flex-column">
    <el-dialog top="2vh" v-if="showMessageShare" title="Chia sẻ" width="520px" :visible.sync="showMessageShare"
               :close-on-click-modal="false"
               :destroy-on-close="true">
      <SharePopup :message="messageShare" :selectConversation="conversation"
                  @closeSharePopup="showMessageShare = false" :message-list="messageList" />
    </el-dialog>
    <el-dialog top="2vh" v-if="replaceBadWord.show"
               :title="'Tin nhắn gửi đi có chứa '+replaceBadWord.items.length+' từ khóa nhạy cảm'" width="500px"
               :visible.sync="replaceBadWord.show"
               :close-on-click-modal="false"
               :destroy-on-close="true">
      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px;overflow-y: auto;">
            <div v-for="(item,index) in replaceBadWord.items" :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input placeholder="Nội dung thay thế" @input="handleInputReplace(item)"
                            v-model="item.replace"></el-input>
                </div>

              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2 ">Nội dung sau chỉnh sửa</div>
        <el-input
          ref="inputText"
          resize="none"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 5}"
          v-model="replaceBadWord.content"
          disabled
        />
        <div class="d-flex justify-content-end mt-2">
          <el-button size="sm" plain type="danger" @click="closeReplaceBadWord()">Hủy</el-button>
          <el-button size="sm" type="primary" @click="sendReplace()">Gửi tin nhắn</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="showImageLibrary" :visible.sync="showImageLibrary" :close-on-click-modal="false" top="40px"
               width="80vw"
               :destroy-on-close="true">
      <ImageLibraryPopup :conversation="conversation" @closeImagePopup="hiddenLibraryPopup()" />
    </el-dialog>
    <el-dialog v-if="createTopic" :visible.sync="createTopic" :close-on-click-modal="false" title="Tạo nhắc hẹn"
               :destroy-on-close="true" width="400px">
      <div class="flex-column">

        <el-input
          ref="inputText"
          type="textarea"
          resize="none"
          :rows="3"
          placeholder="Nhập nội dung mới"
          v-model="topic.title"
        />
        <div class="my-2">Chọn thời gian :</div>
        <el-date-picker
          v-model="topic.startTime"
          type="datetime" class="w-100"
          placeholder="Chọn ngày nhắc hẹn">
        </el-date-picker>
        <div class="my-2">Chọn kiểu lặp lại :</div>
        <el-select
          v-model="topic.repeat"
          class="w-100"
        >
          <el-option
            v-for="(item, index) in repeatType"
            :key="index"
            :label="item.name"
            :value="item.val"
          >
          </el-option>
        </el-select>
        <div class="d-flex mt-3 justify-content-end">
          <el-button type="danger" plain @click="createTopic = false">Hủy</el-button>
          <el-button type="primary" plain @click="createNewTopic()">Tạo nhắc hẹn</el-button>
        </div>
      </div>
    </el-dialog>

    <MessageBoxHeader :data="data"
                      :avatar="conversation.avatar" :conversation="conversation"
                      :online="onlineStatus.online" :to-name="conversation.toName"
                      :last-online-str="onlineStatus.lastOnlineStr" :pin="conversation.isPin" />
    <div class="position-relative">
      <div class="position-absolute d-flex justify-content-center align-items-center fw-semibold"
           style="z-index: 2;width: 100%; height: 50px; background-color: white"
           v-if="data.isBlocked !== null && data.isBlocked === 1 ">
        <div class="text-normal me-2">Bạn đã chặn người này. Người này sẽ không thể trả lời tin nhắn của bạn</div>
        <div>
          <el-button size="mini" type="danger" @click="handleActionBlock('unblock')" plain>Bỏ chặn</el-button>
        </div>

      </div>
    </div>

    <PinMessages ref="pinComponents" :conversation="conversation" :pin-messages="pinMessages"
                 @createOverScreen="createOverScreen()"
                 @removeOverScreen="removeOverScreen()" />
    <RequestFriendBox :conversation="conversation" :data="data"
                      v-if="Object.keys(data).length>0 && conversation.page===false" />
    <div class="flex-grow-1" style="background-color: #ECECEC !important">
      <div class="chat-conversation small-scrollbar" data-simplebar="init" ref="chatConversation"
           id="chat-conversation">
        <div class="simplebar-wrapper">
          <div class="simplebar-height-auto-observer-wrapper">
            <div class="simplebar-height-auto-observer"></div>
          </div>
          <div class="simplebar-mask">
            <div class="simplebar-offset">
              <div class="simplebar-content-wrapper-message" id="message-list"
                   ref="scrollContainer" @scroll="onScroll">
                <div v-if="canLoadMore" class="loadingMore">
                  <ImageLoading :type="'spin'" :color="'#50a5f1'" style="opacity: 0.7" />
                </div>
                <div class="simplebar-content p-3">
                  <div class="sentinel" ref="sentinel"></div>
                  <div v-for="(message, index) in messageList"
                       :key="message.newIdMessage!=undefined?message.newIdMessage: index">
                    <div
                      v-if="message.msgType !== 'chat.delete' && message.msgType !== 'chat.undo'&& message.showPt">
                      <li :class="message.id.uidFrom === '0' ?'right d-block':'left d-block'">
                        <div class="conversation-list"
                             :class="message.id.uidFrom === '0' && message.isActionMessage ?'w-100':''"
                             v-bind:style="message.isActionMessage?'display:block':''">
                          <div class="user-chat-content" style="position: relative">
                            <div class="ctext-wrap"
                                 v-bind:style="message.isActionMessage?'display: block !important':''">
                              <MessageContent
                                v-bind:class="(0 === index && Object.keys(data).length > 0 && data.isFr === 0) ?'mt-40px':'mt-1'"
                                :key="message.id.msgId"
                                :message-list="messageList"
                                :message="message"
                                :conversation-id="conversation.id" :account-id="conversation.accountId"
                                style="word-break: break-word"
                                v-bind:style="!message.isActionMessage?'max-width: 500px':''" />
                            </div>
                            <MessageAction
                              :message="message"
                              @showRepliedMessage="showRepliedMessage"
                              @showMessageSharePopup="showMessageSharePopup"
                              @copy="copy"
                              @dowloadImage="dowloadImage"
                              @undoMessage="undoMessage"
                              @deleteMessage="deleteMessage"
                              @pinMessage="pinMessage"
                            />

                          </div>
                        </div>
                      </li>
                    </div>
                  </div>
                  <div>
                    <li v-if="loadingImage" class="right d-block">
                      <div class="conversation-list">
                        <div class="user-chat-content">
                          <div class="ctext-wrap">
                            <ImageLoading :type="'bubbles'" :color="'#808080'" />
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative">
          <div v-if="showIconNewMessage" @click="handleIconNewMessage()"
               class="position-absolute pointer fw-semibold rounded-2 btn-jump"><span><i
            class="el-icon-d-arrow-left ms-1 me-1 align-self-end" style="rotate: -90deg"></i> </span>Có tin nhắn mới
          </div>
        </div>
      </div>
    </div>
    <div class="position-relative" v-if="showChat">
      <LinkPopup v-if="!showReplied && showLink" :data="linkObject" @closeLinkPopup="showLink=false" />
    </div>
    <MessageBoxTags :conversation="conversation" :tags="tags" />
    <div style="margin-bottom: 2px"></div>
    <div ref="chatMessageReply" v-if="showReplied && showChat" class="mx-1 rounded-3 d-flex p-1"
         style="position: relative; background-color: #eaedf0">
      <img :src="hoveredReplied === 1 ? iconCloseFill : iconClose" @mouseover="hoveredReplied = 1"
           @mouseleave="hoveredReplied = null" @click="closeReplied()"
           class="pointer"
           style="width: 15px;height: 15px;position: absolute; top: 6px;right: 6px">
      <div class="divider-right ms-2"></div>
      <div class="ms-2 d-flex flex-column justify-content-around">
        <div class="" style=""><span class="font-size-12">Trả lời</span> <span
          class="fw-bolder">  {{ conversation.toName }}</span>:
        </div>
        <MessageContent class="text-blur" :messageRepied="true" :message-list="messageList" :message="messageReplied"
                        :conversation-id="conversation.id" />
      </div>

    </div>
    <div class="msg-input d-flex align-items-center p-1" v-if="showChat">
      <div class="flex-grow-1 text-center" @drop="dropHandler">
        <el-input
          ref="inputText"
          resize="none"
          placeholder="Nhập tin nhắn hoặc gõ / để chọn mẫu tin..."
          @keydown.enter.exact.native="sendMessage"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 3}"
          v-model="newMessage"
          @input="handleInput"
          v-debounce:10ms.lock="checkTyping"
          v-debounce:500ms.unlock="unlockTyping"
        />
      </div>
      <div>
        <div class="mx-1 d-flex align-items-center">
          <div v-show="!newMessage">
            <div class="d-flex">


              <li class="list-inline-item" style="margin-right: 0" title="Danh thiếp">
                <el-popover v-model="showBusinessCard" placement="top-end" width="300" trigger="click">
                  <BusinessCard v-if="showBusinessCard" :conversation="conversation"
                                @sendBusinessCard="sendBusinessCardList" />
                  <el-button slot="reference" style="border: none;margin-left: 0"
                             class="p-1 pointer rounded-1 pin flex-1 d-flex align-items-center justify-content-center">
                    <img src="/assets/icon/card_2.svg" class="ic-message d-flex" />
                  </el-button>
                </el-popover>
              </li>
              <li class="list-inline-item" style="margin-right: 0" data-bs-toggle="tooltip" title="Thư viện">
                <el-button @click="showImageLibrary=true" style="border: none;margin-left: 0"
                           class="p-1 pointer rounded-1 pin flex-1 icon-image font-size-18 " />
              </li>
              <li class="list-inline-item" style="margin-right: 0px" title="Tải ảnh lên">
                <input style="display: none;width: 0;height: 0" ref="file" type="file" multiple
                       @change="fileSelected" />
                <el-button @click="$refs.file.click()" style="border: none;margin-left: 0"
                           class="p-1 pointer rounded-1 pin flex-1 icon-attach font-size-18" />
              </li>
              <li class="list-inline-item" style="margin-right: 0" title="Nhắc hẹn">
                <el-button slot="reference" @click="showCreatePopup()" style="border: none;margin-left: 0"
                           class="p-1 pointer rounded-1 pin flex-1 icon-clock  font-size-18" />
              </li>
            </div>
          </div>
          <li class="list-inline-item" style="margin-right: 0" title="Nhãn dán">
            <el-popover placement="top" trigger="click" v-model="stickerVisible">
              <el-button slot="reference" style="border: none;margin-left: 0"
                         class="p-1 pointer pin rounded-1 icon-smile font-size-18 flex-1" />
              <EmojiPicker />
            </el-popover>
          </li>
          <li class="list-inline-item" style="margin-right: 0px" title="Mẫu tin">
            <el-popover v-model="showQuickMessage" placement="top-end" width="350" trigger="click">
              <QuickReplyPopup @selectedMessage="selectMessage" :content="newMessage" />
              <el-button slot="reference" style="border: none;margin-left: 0"
                         class="p-1 pointer rounded-1 pin flex-1 flex-1 icon-mess  font-size-18" />
            </el-popover>
          </li>
          <el-button style="border: none;margin-left: 0" v-bind:class="app.expandMessage?'pe-3':''"
                     class="p-1 pointer rounded-1 pin flex-1 d-flex align-items-center justify-content-center ">
            <img src="/assets/icon/send.svg" class="font-size-20 " @click="sendMessage" />
            <!--          <div type="primary" class="" style="border: 1px solid #0068ff;color: #0068ff;margin-bottom: 0" @click="sendMessage">GỬI</div>-->
          </el-button>
        </div>
      </div>
    </div>
    <div v-if="app.selectedImages.length>0 && showChat" class="d-flex  ms-1 flex-wrap"
         v-bind:style="{'height': HEIGHT_MESSAGE_PASTE  +'px','overflow': 'auto'}" style="margin-bottom: 0px;">
      <div
        style="margin-right: 10px; margin-bottom: 10px; width: 70px; height: 70px; position: relative;"
        v-for="(image, index) in app.selectedImages"
        :key="index"
      >
        <div v-if="image.file">
          <el-image v-if="image.file.type.startsWith('image/')" class="rounded-2" style="width: 70px; height: 70px;"
                    :src="image.url"
                    fit="cover" lazy></el-image>
          <div v-else style="width: 70px; height: 70px;">
            <el-image style="width: 50px; height:50px; margin-left: 10px;"
                      :src="source?source:'https://chat.zalo.me/assets/icon-file-empty.6796cfae2f36f6d44242f7af6104f2bb.svg'"
                      fit="cover" lazy></el-image>
            <el-tooltip slot="reference" effect="dark" :content="image.file.name"
                        placement="top">
              <div
                style="width: 70px; height: 20px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; cursor: pointer; font-weight: bold;">
                {{ image.file.name }}
              </div>
            </el-tooltip>
          </div>
        </div>
        <el-image v-else class="rounded-2" style="width: 70px; height: 70px;" :src="image.url"
                  fit="cover" lazy></el-image>
        <img :src="hovered === index ? iconCloseFill : iconClose" @mouseover="hovered = index"
             @mouseleave="hovered = null" @click="removeImage(index)"
             class="pointer"
             style="width: 15px;height: 15px;position: absolute; top: 3px;right: 2px">
      </div>
    </div>
    <div v-if="!showChat" class="d-flex justify-content-center">
      <div class="">Tài khoản bị ngắt kết nối với Salework</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import MessageContent from "./message/MessageContent";
import MessageAction from "../components/MessageAction";
import MessageBoxHeader from "./message/MessageBoxHeader";
import MessageBoxTags from "./message/MessageBoxTags";
import ImageLoading from "./message/ImageLoading";
import ImageLibraryPopup from "./ImageLibraryPopup";
import SharePopup from "./message/SharePopup";
import LinkPopup from "./message/LinkPopup";
import { COMMON } from "../lib/Common";
import PinMessages from "./message/PinMessages";
import RequestFriendBox from "./message/RequestFriendBox";
// import Sticker from "./Sticker";
import BusinessCard from "./BusinessCard";
import QuickReplyPopup from "./QuickReplyPopup";
// import StringUtil from "../lib/StringUtil";
import EmojiPicker from "./message/EmojiPicker";

export default {
  props: ["conversation", "showChat"],
  components: {
    EmojiPicker,
    QuickReplyPopup,
    BusinessCard,
    // Sticker,
    RequestFriendBox,
    PinMessages,
    LinkPopup,
    SharePopup,
    ImageLibraryPopup,
    ImageLoading,
    MessageBoxTags,
    MessageBoxHeader,
    MessageContent,
    MessageAction
  },
  watch: {
    pinMessages(newValue, oldvalue) {
      this.calculatorPinMessageHeight(newValue, oldvalue);
    },
    imageSelecteds: function() {
      this.calculatorHeightMessage();
    }
  },
  data() {
    return {
      visibleRequestFriend: false,
      showIconNewMessage: false,
      data: {},
      visiblePopup: false,
      pinMessages: [],
      showLink: false,
      linkObject: {},
      messageShare: {},
      showMessageShare: false,
      replaceBadWord: {
        show: false,
        items: [],
        content: ""
      },
      hoveredReplied: null,
      showMessagePaste: false,
      hovered: null,
      iconClose: "/assets/icon/icon_close.svg",
      iconCloseFill: "/assets/icon/icon_close_fill.svg",
      showImageLibrary: false,
      tags: [],
      showReplied: false,
      messageReplied: {},
      canLoadMore: true,
      PAGE_SIZE: 30,
      messageList: [],
      messageView: [],
      newMessage: "",
      onlineStatus: { online: false },
      stickerVisible: false,
      showQuickMessage: false,
      loadingImage: false,
      nextTime: "",
      showBusinessCard: false,
      HEIGHT_MESSAGE_REPLIED: 60,
      HEIGHT_MESSAGE_PASTE: 75,
      HEIGHT_MESSAGE_LINK: 100,
      typing: false,
      replaceUrl: [],
      reactionList: [],
      createTopic: false,
      topic: {},
      repeatType: [
        { name: "Không lặp lại", val: 0 },
        { name: "Hàng ngày", val: 1 },
        { name: "Hàng tuần", val: 2 },
        { name: "Hàng tháng", val: 3 }
      ]
    };
  },
  computed: {
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.conversation.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map(item => [item[key], item])).values()];
      return unique;
    },

    imageSelecteds() {
      return this.app.selectedImages;
    }

  },
  methods: {
    replaceNew(data) {
      if (data.conversationId == this.conversation.id) {
        this.sortMessage("replace");
      }
    },
    reactionNew(data) {
      this.reactionList.push(data);
    },
    EmojiPickup(emoji) {
      this.newMessage = this.newMessage.concat(emoji);
    },
    showPhoto(message) {
      try {
        if (message.msgType == "chat.photo") {
          if (JSON.parse(message.content).params) {
            let params = JSON.parse(JSON.parse(message.content).params);
            if (params.is_group_layout) {
              if (params.id_in_group === 0) {
                return true;
              } else {
                let id = JSON.parse(JSON.parse(message.content).params).group_layout_id;
                let id_in_group = JSON.parse(JSON.parse(message.content).params).id_in_group;

                let idsInGroup = this.messageList.filter(c => {
                  if (c.msgType === "chat.photo") {
                    let params = JSON.parse(JSON.parse(c.content).params);
                    if (params.group_layout_id) {
                      return params.group_layout_id === id;
                    }
                  }
                  return false;
                }).map(s => JSON.parse(JSON.parse(s.content).params).id_in_group);

                if (id_in_group === Math.min(...idsInGroup)) {
                  return true;
                } else {
                  return false;
                }
              }

            }
          }
        }
      } catch (e) {
        return true;
      }
      return true;
    },
    async dowloadImage(message) {
      let groupLayoutId = JSON.parse(JSON.parse(message.content).params).group_layout_id;
      if (groupLayoutId === undefined) {
        let url = JSON.parse(message.content).href;
        this.dowload(url);
        this.alert("success", "Tải ảnh về thành công!");
        return;
      }
      let photos = [];
      let filter = this.messageList.filter(p => p.msgType == "chat.photo");
      filter.forEach(item => {
        let params = JSON.parse(JSON.parse(item.content).params);
        if (params.is_group_layout) {
          if (params.group_layout_id == groupLayoutId) {
            photos.push({ id: params.id_in_group, url: this.findUrlHDIfExist(item.content) });
          }
        }
      });
      photos.forEach(item => {
        this.dowload(item.url);
      });
      if (photos.length > 0) {
        this.alert("success", "Tải ảnh về thành công!");
        return;
      }
      this.alert("error", "Tải ảnh về thất bại!");

    },
    dowload(url) {
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = url;
          document.body.appendChild(link);
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
    },

    findUrlHDIfExist(content) {
      try {
        let linkHD = JSON.parse(JSON.parse(content).params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return linkHD;
        }
      } catch (ex) {
        // Ignore
      }
      return JSON.parse(content).href;
    },


    createOverScreen() {
      this.$refs.chatConversation.style.opacity = "0.2";
    },
    removeOverScreen() {
      if (this.$refs.chatConversation.style !== undefined) {
        this.$refs.chatConversation.style.opacity = "1";
      }
    },

    onScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
        this.showIconNewMessage = false;
      }
    },

    calculatorPinMessageHeight(newValue, oldvalue) {
      if (this.pinMessages.length > 0 && newValue === undefined && oldvalue === undefined) return this.$refs.chatConversation.style.height = `calc( ${this.$refs.chatConversation.style.height} - 52px)`;
      if (newValue === undefined) return;
      if (newValue.length > 0 && oldvalue.length === 0) return this.$refs.chatConversation.style.height = `calc( ${this.$refs.chatConversation.style.height} - 52px)`;
      if (newValue.length === 0 && oldvalue.length > 0) return this.$refs.chatConversation.style.height = `calc( ${this.$refs.chatConversation.style.height} + 52px)`;

    },
    scrollImmediately() {
      this.$nextTick().then(() => {
        let scrollContainer = this.$refs["scrollContainer"];
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: "smooth"
        });
      });
    },
    handleIconNewMessage() {
      this.showIconNewMessage = false;
      this.scrollImmediately();
    },
    handleActionBlock(action) {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
        action: action,
        conversationId: this.conversation.id
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.data.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.data.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
      });
    },
    getAccount() {
      return this.app.accounts.find(s => s.accountId === this.conversation.accountId);
    },

    pinMessage(message) {
      if (this.data.isBlocked === 1) {
        return this.alert("error", "Yêu cầu thực hiện không thành công vì bạn hoặc người này đã chặn nhau");
      }
      if (this.data.isFr === 0) {
        return this.alert("error", "Yêu cầu thực hiện không thành công vì 2 bạn chưa kết bạn trên zalo");
      }
      this.$refs.pinComponents.pinMessage(message);
      message.visiblePopup = false;
    },

    undoMessage(message) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: false,
        msgId: message.id.msgId,
        cliMsgIdUndo: message.cliMsgId
      };
      message.visiblePopup = false;
      if (new Date().getTime() - Number(message.ts) > 24 * 60 * 60 * 1000) return this.alert("error", "Bạn chỉ có thể thu hồi tin nhắn trong vòng 24h");
      this.$http.post("/api/message/undo", request);

    },
    deleteMessage(message) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: false,
        cliMsgId: message.cliMsgId,
        globalMsgId: message.id.msgId,
        ownerId: this.conversation.toId,
        destId: this.conversation.toId
      };
      this.$http.post("/api/message/delete", request);
      message.visiblePopup = false;

    },
    copy(message) {
      let code = message.content;
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      message.visiblePopup = false;
    },

    isGroupPhoto(message) {
      try {
        if (message.msgType == "chat.photo") {
          if (JSON.parse(message.content).params) {
            let params = JSON.parse(JSON.parse(message.content).params);
            if (params.is_group_layout) {
              return true;
            }
          }
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    showMessageSharePopup(message) {
      this.messageShare = message;
      this.showMessageShare = true;
    },
    createNewTopic() {
      if (this.topic.title.length === 0) {
        this.alert("error", "Nhập nội dung");
        return;
      }
      if (new Date(this.topic.startTime).getTime() === 0) {
        this.alert("error", "Bạn chưa chọn thời gian");
        return;
      }
      if (new Date(this.topic.startTime).getTime() < new Date().getTime()) {
        this.alert("error", "Nhập lại thời gian");
        return;
      }
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        startTime: new Date(this.topic.startTime).getTime(),
        title: this.topic.title,
        repeat: this.topic.repeat
      };
      this.$http.post("/api/message/createTopic", request).then(resp => {
        if (resp.data.error_code === -20017) {
          return this.alertError("Yêu cầu không thành công vì 2 bạn chưa kết bạn trên Zalo");
        }
      });
      this.createTopic = false;
    },
    showCreatePopup() {
      this.topic = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        startTime: new Date(),
        title: "",
        repeat: 0
      };
      this.createTopic = true;
    },
    calculatorHeightMessage() {
      if (this.showReplied) {
        if (this.app.selectedImages.length === 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height} )`;
          this.calculatorPinMessageHeight();
          return;
        }
        this.$refs.chatMessageReply.style.height = this.HEIGHT_MESSAGE_REPLIED + "px";
        this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height} - ${this.HEIGHT_MESSAGE_PASTE + "px"})`;
        this.calculatorPinMessageHeight();
      } else {
        if (this.app.selectedImages.length === 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px)`;
          this.calculatorPinMessageHeight();
          return;
        }
        this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.HEIGHT_MESSAGE_PASTE + "px"})`;
        this.calculatorPinMessageHeight();
      }
    },

    removeImage(index) {
      this.hovered = null;
      this.app.selectedImages.splice(index, 1);
    },
    hiddenLibraryPopup() {
      this.showImageLibrary = false;
    },
    showRepliedMessage(message) {
      this.showLink = false;
      this.showReplied = true;
      this.messageReplied = message;
      this.$nextTick(() => {
        this.$refs.chatMessageReply.style.height = this.HEIGHT_MESSAGE_REPLIED + "px";
        if (this.app.selectedImages.length > 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height} - ${this.HEIGHT_MESSAGE_PASTE + "px"})`;
        } else {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height})`;
        }
        if (this.showChat) {
          this.$refs.inputText.focus();
        }
        this.calculatorPinMessageHeight();

      });
    },
    closeReplied() {
      this.messageReplied = {};
      this.showReplied = false;
      this.restoreHeightChatAfterReplied();
    },
    restoreHeightChatAfterReplied() {
      this.$nextTick(() => {
        if (this.app.selectedImages.length > 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px  -  ${this.HEIGHT_MESSAGE_PASTE + "px"})`;
        } else {
          this.$refs.chatConversation.style.height = "calc(100vh - 196px - 23px)";
        }
        this.calculatorPinMessageHeight();
      });
      this.hoveredReplied = null;
    },

    replyMessage() {
      let message = this.messageReplied;

      let request = {
        conversationId: this.conversation.id,
        toId: this.conversation.toId,
        accountId: this.conversation.accountId,
        message: this.newMessage,
        ownerId: message.id.uidFrom != "0" ? message.id.uidFrom : this.conversation.accountId,
        replyMsgId: message.id.msgId,
        replyMsgClientId: message.cliMsgId,
        replyMsgTs: message.ts
      };
      let url;
      if (message.msgType === "webchat") {
        request.replyMsg = message.content;
        url = "/api/message/replyMessage";
      } else if (message.msgType === "chat.photo") {
        let content = JSON.parse(message.content);
        content.oriUrl = content.hdUrl = content.normalUrl = content.href;
        content.thumbUrl = content.thumb;
        request.replyMsgAttach = content;
        url = "/api/message/replyPhoto";
      } else if (this.isLinkMessage(message)) {
        url = "/api/message/replyPhoto";
        let content = JSON.parse(message.content);
        content.type = "38";
        request.replyMsgAttach = content;

      }

      this.$http.post(url, request).then(() => {
      }).catch(() => {
        this.alert("error", "Có lỗi xảy ra ");
      }).finally(() => {
      });
      this.showReplied = false;
      this.newMessage = "";
      this.restoreHeightChatAfterReplied();
    },

    recordScrollPosition() {
      let node = this.$refs["scrollContainer"];
      this.previousScrollHeightMinusScrollTop =
        node.scrollHeight - node.scrollTop;
    },
    sendBusinessCard(item) {
      let request = {
        friendId: item,
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        conversationId: this.conversation.id
      };
      this.$http.post("/api/message/sendContact", request).then(() => {
      });
    },
    async sendBusinessCardList(items) {
      for (const item of items) {
        await this.sendBusinessCard(item);
      }
      this.showBusinessCard = false;
    },
    restoreScrollPosition() {
      let node = this.$refs["scrollContainer"];
      node.scrollTop =
        node.scrollHeight - this.previousScrollHeightMinusScrollTop;
    },
    setUpInterSectionObserver() {
      let options = {
        root: this.$refs["scrollContainer"],
        margin: "10px"
      };
      this.listEndObserver = new IntersectionObserver(
        this.handleIntersection,
        options
      );

      this.listEndObserver.observe(this.$refs["sentinel"]);
    },
    handleIntersection([entry]) {
      if (entry.isIntersecting && this.canLoadMore) {
        this.loadMore();
      }
    },
    async loadMore() {
      this.recordScrollPosition();
      await this.fetchMessageList();

      this.$nextTick(() => {
        setTimeout(() => {
          this.restoreScrollPosition();
        }, 0);
      });
    },
    async fetchMessageList() {
      await this.$http.post("/api/message/filter", {
        conversationId: this.conversation.id,
        accountId: this.conversation.accountId,
        timestamp: this.nextTime,
        pageSize: this.PAGE_SIZE
      }).then((resp) => {
        if (resp.data.length > 0) {
          resp.data.forEach(s => s.visiblePopup = false);
          this.messageList.unshift(...resp.data.reverse());
          this.nextTime = resp.data[0].ts;
        }

        if (this.PAGE_SIZE !== resp.data.length) {
          this.canLoadMore = false;
        }
        this.sortMessage("new");
        this.convertToDoMessage(this.messageList);
      });
    },
    initializaInterSectionObserver(ms = 0) {
      setTimeout(() => {
        this.$nextTick().then(() => {
          let scrollContainer = this.$refs["scrollContainer"];
          scrollContainer.scrollTop = scrollContainer.scrollHeight;
          this.$nextTick().then(() => {
            this.setUpInterSectionObserver();
          });
        });
      }, ms);
    },
    async getInitializationMessages() {
      await this.fetchMessageList();
      this.unread(this.conversation.id);
      if (this.messageList.filter(s => s.msgType === "webchat").length > 20) {
        this.initializaInterSectionObserver(200);
      } else {
        this.initializaInterSectionObserver(500);
      }
    },

    handlePinMessageFromWebHook(message) {
      try {
        if (message.msgType === COMMON.WEBCHAT && this.isJsonString(message.content)) {
          let content = JSON.parse(message.content);
          if (content.action !== "msginfo.actionlist") return;
          let params = JSON.parse(content.params);
          let actions = params.actions[0];
          if (actions === undefined || actions === null) {
            return this.getPinList();
          }
          let actionType = actions.actionType;
          if ([COMMON.PIN_MESSAGE, COMMON.UNPIN_MESSAGE].includes(actionType)) {
            this.getPinList();
          }
        }
      } catch (err) {
        // toDo
      }
    },
    sortMessage(type, clientMsgId) {
      if (clientMsgId) {
        let messageFt = this.messageList.filter((p) => p.cliMsgId == clientMsgId);
        if (messageFt != null && messageFt.length > 0) {
          let undoList = this.messageList.filter(m => m.msgType == "chat.delete" || m.msgType == "chat.undo");
          let filter = this.messageList.filter(p => p.msgType == "chat.photo");
          let newMes = this.parseMessage(messageFt[0], "new", undoList, filter);
          let index = this.messageList.indexOf(messageFt[0]);
          if (index > -1) {
            this.messageList.splice(index, 1);
          }
          this.messageList.push(newMes);
        }
      } else {
        let undoList = this.messageList.filter(m => m.msgType == "chat.delete" || m.msgType == "chat.undo");
        let filter = this.messageList.filter(p => p.msgType == "chat.photo");
        this.messageList.map(message => {
          return this.parseMessage(message, type, undoList, filter);
        });
      }
      this.messageList = this.messageList.sort((a, b) => Number(a.ts) - Number(b.ts));
    },

    addMessage(message) {
      if (message.id.conversationId == this.conversation.id) {
        let filter = this.messageList.filter(m => m.cliMsgId == message.cliMsgId && m.id.msgId === message.id.msgId);
        if (filter != null && filter.length > 0) {
          let index = this.messageList.indexOf(filter[0]);
          if (index > -1) {
            this.messageList.splice(index, 1);
          }
        }
        this.handleTodoMessageFromWebhook(message, this.messageList);
        this.messageList.push(message);
        let clientMsgId = null;
        try {
          if (message.msgType == "chat.delete") {
            let item = JSON.parse(message.content)[0];
            clientMsgId = item.clientDelMsgId;
          }
          if (message.msgType == "chat.undo") {
            let item = JSON.parse(message.content);
            clientMsgId = item.cliMsgId;
          }
        } catch (ex) {
          //
        }
        this.sortMessage("new", clientMsgId);
        this.handlePinMessageFromWebHook(message);
        if (clientMsgId) {
          //
        } else {
          if (message.id.uidFrom === "0") {
            this.scrollImmediately();
          }
          if (message.id.uidFrom !== "0") {
            let scrollContainer = this.$refs["scrollContainer"];
            if (scrollContainer.scrollTop < scrollContainer.scrollHeight - scrollContainer.clientHeight - 50) {
              this.showIconNewMessage = true;
            } else {
              this.scrollImmediately();
            }
          }
        }
        if (this.showIconNewMessage === false) this.unread(this.conversation.id);
      }
    },
    selectMessage(message) {
      this.newMessage = message.content;
      this.showQuickMessage = false;
      this.pushSelectImages(message);
    },
    getQuickMessage() {
      this.showQuickMessage = false;
      if (this.newMessage.startsWith("/") && this.app.quickReplyList.length > 0) {
        this.showQuickMessage = true;
        let quickStart = this.app.quickReplyList.filter((item) => ("/" + item.code).startsWith(this.newMessage));
        if (quickStart != null && quickStart.length == 1) {
          this.newMessage = quickStart[0].content + " ";
          this.pushSelectImages(quickStart[0]);
          this.showQuickMessage = false;
        } else {
          let quick = this.app.quickReplyList.filter((item) => ("/" + item.code + " ") == this.newMessage);
          if (quick != null && quick.length == 1) {
            this.newMessage = quick[0].content + " ";
            this.pushSelectImages(quick[0]);
            this.showQuickMessage = false;
          }
        }
        // if (quick != null && quick.length > 0) {
        //   this.newMessage = quick[0].content + " ";
        //   this.showQuickMessage = false;
        // }
      }
    },
    handleInput() {
      this.getQuickMessage();
      this.handleLink();
      // this.filterCharacter();
      this.app.listDraft.set(this.conversation.id, this.newMessage);

    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter(p => p.accountId == this.conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.newMessage;
        let arr = text.split(" ");
        if (this.filterCharacterArr && this.filterCharacterArr.length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    isEmptyObject(item) {
      return Object.keys(item).length === 0;
    },
    resetLinkDefault() {
      this.showLink = false;
      this.linkObject = {};
    },
    splitWhiteSpace(item) {
      return item.split(/\s+/);
    },
    handleLink() {
      this.newMessage = this.newMessage.trimStart();
      if (this.showReplied) return this.resetLinkDefault();

      let arrLinks = this.detectURLs(this.newMessage);
      if (arrLinks == null) return this.resetLinkDefault();

      let arrsSplit = this.splitWhiteSpace(this.newMessage);
      if (arrsSplit.length === 1 && arrLinks[0] === this.newMessage && this.isEmptyObject(this.linkObject)) return this.parseLink(arrLinks[0]);
      if (arrsSplit.length > 1) {
        let index = arrsSplit.indexOf(arrLinks[0]);
        if (arrsSplit[index + 1] !== undefined) {
          if (this.isEmptyObject(this.linkObject)) return this.parseLink(arrLinks[0]);
          if (![this.linkObject.href, this.linkObject.src].includes(arrLinks[0].trim())) return this.parseLink(arrLinks[0]);
        }
      }
    },
    parseLink(link) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        link: link
      };
      this.$http.post("/api/message/parseLink", request).then((resp) => {
        if (Object.keys(resp.data).length > 0) {
          this.linkObject = resp.data.data;
          this.showLink = true;
        } else {
          this.resetLinkDefault();
        }
      });
    },
    sendLink(item) {
      if (item.title !== undefined && item.title.length === 0) {
        this.sendTextMessage();
        this.newMessage = "";
        this.showLink = false;
        this.linkObject = {};
        return;
      }

      let request = {
        conversationId: this.conversation.id,
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        media: JSON.stringify(item.media),
        desc: item.desc,
        href: item.href,
        src: item.src,
        thumb: item.thumb,
        title: item.title,
        link: this.newMessage
      };
      this.$http.post("/api/message/sendLink", request).finally(() => {
        this.newMessage = "";
        this.showLink = false;
        this.linkObject = {};
      });
    },
    sendFileClipborad() {
      let urlsFromQuickMessage = this.app.selectedImages.filter(s => !s.file).map(s => s.url);
      if (this.app.selectedImages.length === 1) {
        if (urlsFromQuickMessage.length === 1) {
          this.sendMsgPhoto(null, 0, 0, 0, this.getIdFromUrl(urlsFromQuickMessage[0]));
        } else {
          this.sendMsgFile(this.app.selectedImages[0].file, 0, 0, 0);
        }
      } else {
        let groupId = new Date().getTime();
        for (let i = 0; i < this.app.selectedImages.length; i++) {
          let totalItems = this.app.selectedImages.length;
          let s = this.app.selectedImages[i];
          if (s.file) {
            this.sendMsgFile(s.file, groupId, totalItems, i);
          } else {
            this.sendMsgPhoto(null, groupId, totalItems, i, this.getIdFromUrl(s.url));
          }
        }
      }
      this.app.selectedImages = [];
    },
    sendReplace() {
      this.newMessage = this.replaceBadWord.content;
      this.sendMesV2(this.replaceBadWord.items.map((k) => {
        return k.key;
      }), true);
      this.closeReplaceBadWord();
    },
    closeReplaceBadWord() {
      this.replaceBadWord.show = false;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr) {

          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    deleteReplace(item) {
      let filter = this.replaceBadWord.items.filter((con) => con.key == item.key);
      if (filter != null && filter.length > 0) {
        const index = this.replaceBadWord.items.indexOf(filter[0]);
        if (index > -1) {
          this.replaceBadWord.items.splice(index, 1);
          this.replaceBadWordContent();
        }
      }
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.newMessage;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    sendTextMessage() {
      if (this.newMessage.length > 0) {
        let items = this.filterCharacter();
        if (items.length > 0) {
          this.replaceBadWord.show = true;
          this.replaceBadWord.items = items;
          this.replaceBadWordContent();
          // let keys = items.map((t) => {
          //   return t.text;
          // }).filter((value, index, array) => array.indexOf(value) === index);
          // let msg = "Từ khóa nhạy cảm ";
          // keys.forEach((k) => {
          //   msg += "'" + k + "',";
          // });
          // msg = msg.substring(0, msg.length - 1);
          // msg += " sẽ được thay thế bằng '****'";
          // this.$confirm(msg, "Tin nhắn gửi đi có chứa từ khóa nhạy cảm", {
          //   confirmButtonText: "Thay thế & gửi",
          //   cancelButtonText: "Tiếp tục gửi",
          //   type: "warning"
          // })
          //   .then(() => {
          //     let text = this.newMessage;
          //     items.forEach(e => {
          //       text = StringUtil.replaceAt({
          //         originalText: text,
          //         replaceText: "****",
          //         startIndex: e.index - e.text.length,
          //         endIndex: e.index
          //       });
          //     });
          //     this.newMessage = text;
          //
          //     this.sendMesV2(keys, true);
          //   }).catch(() => {
          //   this.sendMesV2(keys, false);
          // });
        } else {
          this.sendMesV2();
        }
      }
    },

    sendMesV2(keys, replace) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        message: this.newMessage,
        conversationId: this.conversation.id,
        bannedKeyword: keys ? keys : [],
        replace: replace
      };
      this.newMessage = "";
      this.$http.post("/api/message/sms", request);
      this.handleDraftMessage(this.newMessage, this.conversation.id);
    },
    sendMessage(event) {
      event.preventDefault();
      if (!this.newMessage.trim().length && this.app.selectedImages.length === 0) return this.alert("error", "Nhập nội dung cần gửi.");

      if (this.showReplied) {
        if (this.newMessage.trim().length > 0) this.replyMessage();
        if (this.app.selectedImages.length > 0) this.sendFileClipborad();
        return this.showReplied = false;
      }

      if (this.newMessage.trim().length > 0) {
        if (Object.keys(this.linkObject).length > 0 && this.showLink) {
          this.sendLink(this.linkObject);
        } else {
          this.sendTextMessage();
        }
      }
      if (this.app.selectedImages.length > 0) this.sendFileClipborad();
    },

    getOnlineStatus() {
      this.$http
        .get("/api/message/onlineStatus", {
          params: {
            accountId: this.conversation.accountId,
            toId: this.conversation.toId
          }
        })
        .then(resp => {
          if (resp.data.data) {
            this.onlineStatus = resp.data.data;
            let now = moment(new Date());
            var end = moment(this.onlineStatus.lastOnline);
            var duration = moment.duration(now.diff(end));

            let minutes = duration.asMinutes();
            let hours = duration.asHours();
            let days = duration.asDays();

            this.onlineStatus.online = false;
            if (minutes < 1) {
              this.onlineStatus.online = true;
              this.onlineStatus.lastOnlineStr = "Vừa mới truy cập";
            } else if (minutes < 60) {
              this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(minutes) + " phút trước.";
            } else if (hours < 24) {
              this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(hours) + " giờ trước.";
            } else if (days < 10) {
              this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(days) + " ngày trước.";
            }
          }
        });
    },
    async fetchAllTag() {
      let resp = await this.$http.get("/api/tag");
      this.tags = resp.data;
    },
    createNewMessageFile(cliMsgId) {
      let message = {};
      let id = message.id = {};
      id.conversationId = this.conversation.id;
      id.idTo = this.conversation.toId;
      id.msgId = new Date().getTime().toString();
      id.uidFrom = "0";
      message.cliMsgId = cliMsgId;
      message.msgType = COMMON.LOADING_FILE;
      message.ts = new Date().getTime().toString();
      return message;
    },
    removeLoadingFile(cliMsgId) {
      let index = this.messageList.findIndex(s => s.cliMsgId === cliMsgId && s.msgType === COMMON.LOADING_FILE);
      if (index > -1) {
        this.messageList.splice(index, 1);
      }
    },
    fileSelected() {
      let groupId = new Date().getTime();
      let totalItems = this.$refs.file.files.length;
      if (totalItems === 1) {
        return this.sendMsgFile(this.$refs.file.files[0], 0, 0, 0);
      }
      this.$refs.file.files.forEach(async (item, index) => {
        await this.sendMsgFile(item, groupId, totalItems, index);
      });
      this.$refs.file.value = null;

    },
    async sendFile(file, bodyFormData) {
      let cliMsgId = new Date().getTime();
      try {
        let message = this.createNewMessageFile(cliMsgId);
        message.fileName = file.name;
        message.size = file.size;
        message.contentType = file.type;
        this.messageList.push(message);
        // this.messageList = this.messageList.sort((a, b) => Number(a.ts) - Number(b.ts));
        this.sortMessage("new");
      } catch (e) {
        this.removeLoadingFile(cliMsgId);
      }
      try {
        await this.$http.post("/api/message/sendMsgFile", bodyFormData);
      } finally {
        this.removeLoadingFile(cliMsgId);
      }
    },
    async sendMsgFile(file, groupId, totalItems, idInGroup) {
      if (this.hasErrorSendFile(file)) return;
      var bodyFormData = new FormData();
      bodyFormData.append("conversationId", this.conversation.id);
      bodyFormData.append("file", file);
      bodyFormData.append("accountId", this.conversation.accountId);
      bodyFormData.append("toId", this.conversation.toId);
      bodyFormData.append("isGroup", false);
      if (["image/png", "image/jpeg", "image/svg", "image/gif"].includes(file["type"])) {
        await this.sendMsgPhoto(file, groupId, totalItems, idInGroup);
      } else {
        await this.sendFile(file, bodyFormData);
      }
    },
    async sendMsgPhoto(file, groupId, totalItems, idInGroup, idFromQuickMessage) {
      if (file && this.hasErrorSendFile(file)) return;
      var bodyFormData = new FormData();
      bodyFormData.append("conversationId", this.conversation.id);
      bodyFormData.append("file", file);
      bodyFormData.append("accountId", this.conversation.accountId);
      bodyFormData.append("toId", this.conversation.toId);
      if (idFromQuickMessage) {
        bodyFormData.append("id", idFromQuickMessage);
      }
      await this.$http.post("/api/message/sendMsgPhoto?groupId=" + groupId + "&totalItems=" + totalItems + "&idInGroup=" + idInGroup, bodyFormData);
    },
    checkTyping(val, e) {
      if (e.type == "input" && val.length > 0 && !this.typing) {
        this.typing = true;
        this.sendTypingSocket("typing");
      }
    },
    unlockTyping(val) {
      if (val.length == 0) {
        this.sendTypingSocket("stopped_typing");
        this.typing = false;
      }
    },
    sendTypingSocket(type) {
      let request = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        type: type,
        username: this.app.user.swUsername
      };
      this.$http.post("/api/conversation/typing", request);
    },
    sendBy(data) {
      if (data.accountId == this.conversation.accountId && data.toId == this.conversation.toId) {
        this.sortMessage("sendBy");
      }
    },
    detectURLs(message) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return message.match(urlRegex);
    },
    copyFile(e) {
      // Handle the event
      this.retrieveImageFromClipboardAsBlob(e, function(imageBlob) {
        // If there's an image, display it in the canvas
        if (imageBlob) {
          // Crossbrowser support for URL
          var URLObj = window.URL || window.webkitURL;
          var url = URLObj.createObjectURL(imageBlob);
          var image = {
            file: imageBlob,
            url: url
          };
          if (this.app.selectedImages) this.app.selectedImages.push(image);
          else {
            this.app.selectedImages = [];
            this.app.selectedImages.push(image);
          }
        }
      }.bind(this));
    },

    retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
      if (pasteEvent.clipboardData == false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      var items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        // if (items[i].type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i].getAsFile();

        if (typeof callback == "function") {
          callback(blob);
        }
      }
    },

    getProfileInfo() {
      this.data = {};
      this.$http.get("/api/message/getProfileInfo", {
        params: {
          accountId: this.conversation.accountId,
          profileId: this.conversation.toId
        }
      }).then((reps) => {
        this.data = reps.data.data.changed_profiles[this.conversation.toId];

      });
    },
    getPinList() {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: false
      };
      this.$http.post("/api/conversation/pinMsgList", request).then((resp) => {
        this.pinMessages = [];
        let items = resp.data?.data?.data;
        if (items === undefined) return;
        items.forEach(item => {
          let params = JSON.parse(item.params);
          params.id = item.id;
          params.type = item.type;
          params.visible = false;
          this.pinMessages.push(params);
        });

        if (this.pinMessages.length === 0) this.removeOverScreen();
      });
    },
    getNewMessageHistory() {
      if (this.app.listDraft.has(this.conversation.id)) {
        this.newMessage = this.app.listDraft.get(this.conversation.id);
      } else {
        this.newMessage = "";
      }

    }
  },

  mounted() {
    this.newMessage = this.getDraftMessageHistory(this.conversation.id);
    // this.getNewMessageHistory();
    // this.newMessage = this.app.listDraft.get(this.conversation.id);
    this.app.isComponentMessageOpen = true;
    this.$bus.$on("handleBlock", data => {
      if (data.toId === this.conversation.toId) {
        if (data.action === "block") {
          this.data.isBlocked = 1;
        } else {
          this.data.isBlocked = 0;
        }
      }
    });
    this.getProfileInfo();
    this.getPinList();
    this.$refs.chatConversation.style.height = "calc(100vh - 196px - 23px)";
    if (this.showChat) {
      this.$refs.inputText.focus();
    }
    window.addEventListener("paste", this.copyFile, false);
    this.app.selectedImages = [];
    this.fetchAllTag();
    this.getOnlineStatus();
    this.getInitializationMessages();
  },

  created() {
    this.$bus.$on("emoji_click", data => {
      this.EmojiPickup(data);
    });
    this.$bus.$on("sendByEvent", (data) => {
        this.sendBy(data);
      }
    );
    this.$bus.$on("ReplaceLinkEvent", (data) => {
        this.replaceNew(data);
      }
    );
    this.$bus.$on("zaloReaction", (data) => {
        this.reactionNew(data);
      }
    );
  },
  beforeDestroy() {
    this.handleDraftMessage(this.newMessage, this.conversation.id);
    this.app.isComponentMessageOpen = false;
    this.messageList = [];
    this.replaceUrl = [];
    this.tags = [];
    this.$bus.$off("emoji_click");
    window.removeEventListener("paste", this.copyFile, false);
  }
};
</script>

<style scoped>
.sentinel {
  height: 0px;
}

.mt-40px {
  margin-top: 40px;
}

.loadingMore {
  text-align: center;
}
</style>
